import React, { Component } from 'react';
import { CashInModal, CashOutModal, RefMoveCashModal, MoneyMovements } from '../components';
import '../css/tablesPOS.css';
import '../css/responsive.css'
import moment from 'moment';
import { CURRENCY, FORMAT_NUMBER, SYMBOL } from '../libs/utils/Const';

class WithdrawalModal extends Component {

    async componentDidMount() {
        const { GetBankAccounts } = this.props;
        GetBankAccounts();
    }

    DoSearch = async (data, searchTerm) => {
        const tableReg = document.getElementById(data);
        const searchText = document.getElementById(searchTerm).value.toLowerCase();
        let total = 0;
        // Recorremos todas las filas con contenido de la tabla
        for (let i = 1; i < tableReg.rows.length; i++) {
            // Si el td tiene la clase "noSearch" no se busca en su contenido
            if (tableReg.rows[i].classList.contains("noSearch")) {
                continue;
            }
            let found = false;
            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');
            // Recorremos todas las celdas
            for (let j = 0; j < cellsOfRow.length && !found; j++) {
                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();
                // Buscamos el texto en el contenido de la celda
                if (searchText.length === 0 || compareWith.indexOf(searchText) > -1) {
                    found = true;
                    total++;
                }
            }
            if (found) {
                tableReg.rows[i].style.display = '';
            } else {
                // si no ha encontrado ninguna coincidencia, esconde la
                // fila de la tabla
                tableReg.rows[i].style.display = 'none';
            }
        }
        // mostramos las coincidencias
        const lastTR = tableReg.rows[tableReg.rows.length - 1];
        const td = lastTR.querySelector("td");
        lastTR.classList.remove("hide", "red");
        if (searchText == "") {
            lastTR.classList.add("hide");
        } else if (total) {
            td.innerHTML = "Se ha encontrado " + total + " coincidencia" + ((total > 1) ? "s" : "");
        } else {
            lastTR.classList.add("red");
            td.innerHTML = "No se han encontrado coincidencias";
        }
    }

    render() {
        const {
            Movements,
            ShowWithdrawalModal,
            GetMovementsCash,
            showRefMoveCashModal, 
            _user,
            PrintCashMovements,
            //
            PaymentSaleModel,
            ShowHideMoneyMovements,
            AvailablePayments,
            newOrderModel,
            addingPay,
            AddPay,
            GetBankAccounts,
            CancelMoneyMovement,
            SendCashMovement,
            ChangeActionMoneyMovements,
            Action,
            RefreshPaymentSaleModel,
            showAlert,
            RefreshOrder,
            BankAccounts,
            ShowRefMoveCashModal,
            cashMovementModel,
            ChangeComment

        } = this.props;
        
        return (
            <div>
                <div className="modal fade  modal-fullscreen" id="withdrawalModal" data-backdrop="false" data-keyboard="false" tabIndex="-1" aria-labelledby="withdrawalModalLabel" aria-hidden="true">
                    <div className="modal-dialog" >
                        <div className="modal-content">
                            <div className="modal-header" style={{ background: "#343a40" }}>
                                <img src={require('../images/logocounter.png')} className="image" alt="COUNTER ONE" />
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={ShowWithdrawalModal} style={{ color: "white" }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row m-3">
                                    <h3 className="modal-title ml-3 mb-2 mt-3" >Entradas y retiros</h3>
                                </div>
                                <div className="row m-3">
                                    <div className="col-xl-12 mb-4 mb-xl-0">
                                        <section>
                                            <ul className="nav nav-tabs" id="myTab" role="tablist">

                                                <li className="nav-item waves-effect waves-light">
                                                    <a className="nav-link active" id="ingresos-tab" data-toggle="tab" href="#ingresos" role="tab" aria-controls="ingresos" aria-selected="true" onClick={() => GetMovementsCash(1)}><h6>Entradas</h6></a>
                                                </li>
                                                <li className="nav-item waves-effect waves-light">
                                                    <a className="nav-link" id="egresos-tab" data-toggle="tab" href="#egresos" role="tab" aria-controls="egresos" aria-selected="false" onClick={() => GetMovementsCash(2)}><h6>Salidas</h6></a>
                                                </li>
                                            </ul>
                                            <div className="tab-content" id="myTabContent" style={{ border: "1px solid #dee2e6", borderTop: "none" }}>
                                                {/* -------------------------------------INGRESOS--------------------------------------------------------- */}
                                                <div className="tab-pane fade active show" id="ingresos" role="tabpanel" aria-labelledby="ingresos-tab">
                                                    <div className="row p-3">
                                                        <div className="col-12 col-md-3">
                                                            <input
                                                                type="text"
                                                                className="form-control "
                                                                placeholder="Buscar"
                                                                id="inSearch"
                                                                onKeyUp={() => this.DoSearch("inData", "inSearch")} />
                                                        </div>
                                                        <div className="col-12 col-md-3">

                                                        </div>
                                                        <div className="col-12 col-md-6 text-right" >
                                                            <button type="button" className="btn btn-outline-success" onClick={() => { ShowHideMoneyMovements(true); ChangeActionMoneyMovements(1) }}>
                                                                <i className="fa fa-plus-circle mr-2" aria-hidden="true" />
                                                                Nueva entrada
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className='scrollTable' >
                                                        <table className="table table-striped table-hover" id="inData" >
                                                            <thead>
                                                                <tr>
                                                                    <th>N° Documento</th>
                                                                    <th>Consecutivo</th>
                                                                    <th>Fecha</th>
                                                                    <th>Hora</th>
                                                                    {/* <th className="text-center">Descripción</th> */}
                                                                    <th className="text-left">Tipo</th>
                                                                    <th>Monto</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {!!Movements && Movements.map((movement, index) => {
                                                                    return (
                                                                        <tr key={`infresosWithdrawal${movement.docNum + index}`}>

                                                                            <td><strong>{movement.folio ?? ''}</strong></td>
                                                                            <td>{movement?.nextFolio ?? ''}</td>
                                                                            <td>{moment(movement.docDate).format('YYYY-MM-DD')}</td>
                                                                            <td>{/*moment(movement.docTime).format('LTS') ||*/ movement.docTime}</td>
                                                                            {/* <td className="text-center">{movement.comments}</td> */}
                                                                            <td className="text-left"><i className="fa fa-plus-circle" aria-hidden="true" style={{ color: "#28a745" }} /> {movement.pm_Name ? movement.pm_Name.toUpperCase() : ''}</td>
                                                                            <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(movement.docTotal)}</td>
                                                                            <td>
                                                                                <button className='btn btn-primary' onClick={() => PrintCashMovements("ChashIn", "80", movement)} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                                                    <i className="fa fa-print" aria-hidden="true"></i>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                                <tr className='noSearch hide'>
                                                                    <td colSpan="7"></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                {/* -------------------------------------EGRESOS----------------------------------------------- */}
                                                <div className="tab-pane fade" id="egresos" role="tabpanel" aria-labelledby="egresos-tab">
                                                    <div className="row p-3">
                                                        <div className="col-12 col-md-3">
                                                            <input
                                                                type="text"
                                                                className="form-control "
                                                                placeholder="Buscar"
                                                                id="outSearch"
                                                                onKeyUp={() => this.DoSearch("outData", "outSearch")} />
                                                        </div>
                                                        <div className="col-12 col-md-3"></div>
                                                        <div className="col-12 col-md-6 text-right" >
                                                            <button type="button" className="btn btn-outline-danger" onClick={() => { ShowHideMoneyMovements(true); ChangeActionMoneyMovements(2) }}>
                                                                <i className="fa fa-minus-circle mr-2" aria-hidden="true" />
                                                                Nueva salida
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className='scrollTable' >
                                                        <table className="table table-striped table-hover" id="outData">
                                                            <thead>
                                                                <tr>
                                                                    <th>N° Documento</th>
                                                                    <th>Consecutivo</th>
                                                                    <th>Fecha</th>
                                                                    <th>Hora</th>
                                                                    {/* <th className="text-center">Descripción</th> */}
                                                                    <th className="text-center">Tipo</th>
                                                                    <th>Monto</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                
                                                                {!!Movements && Movements.map((movement, index) => {
                                                                    return (
                                                                        <tr key={`egresosWithdrawal${movement.docNum + index}`}>
                                                                            <td><strong>{movement.folio}</strong></td>
                                                                            <td>{movement?.nextFolio ?? ''}</td>
                                                                            <td>{moment(movement.docDate).format('YYYY-MM-DD')}</td>
                                                                            <td>{movement.docTime}</td>
                                                                            {/* <td className="text-center">{movement.comments}</td> */}
                                                                            <td className="text-center"><i className="fa fa-minus-circle" aria-hidden="true" style={{ color: "#dc3545" }} /> {movement.pm_Name ? movement.pm_Name.toUpperCase() : ''}</td>
                                                                            <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(movement.docTotal)}</td>
                                                                            <td>
                                                                                <button className='btn btn-primary' onClick={() => PrintCashMovements("ChashOut", "80", movement)} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                                                    <i className="fa fa-print" aria-hidden="true"></i>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    )

                                                                })}
                                                                <tr className='noSearch hide'>
                                                                    <td colSpan="7"></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={ShowWithdrawalModal}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <CashInModal {...this.props} />
                <CashOutModal {...this.props} />
                {showRefMoveCashModal &&
                    <RefMoveCashModal
                        {...this.props}
                        ShowRefMoveCashModal={()=>ShowRefMoveCashModal}
                        Folio={''}
                        PrintCashMovements={PrintCashMovements}
                        _user={_user}
                        action={'PointOfSale'}
                    />}
                {/* {enableMoneyMovements && */}
                <MoneyMovements
                    PaymentSaleModel={PaymentSaleModel}
                    AvailablePayments={AvailablePayments}
                    newOrderModel={newOrderModel}
                    addingPay={addingPay}
                    AddPay={AddPay}
                    GetBankAccounts={GetBankAccounts}
                    CancelMoneyMovement={CancelMoneyMovement}
                    SendCashMovement={SendCashMovement}
                    Action={Action}
                    RefreshPaymentSaleModel={RefreshPaymentSaleModel}
                    showAlert={showAlert}
                    RefreshOrder={RefreshOrder}
                    BankAccounts={BankAccounts}
                    cashMovementModel={cashMovementModel}
                    ChangeComment={ChangeComment}
                />
                {/* } */}

            </div>
        );
    }
}

export default WithdrawalModal;